const ALLOWED_STYLES = new Set([
  'width',
  'height',
  'transform',
  'transition',
  'display',
]);

export function filterCssPropertiesFromMetadata(
  metadata: Record<string, string> | null,
): Record<string, string> {
  if (!metadata || typeof metadata !== 'object') return {};

  return Object.fromEntries(
    Object.entries(metadata).filter(
      ([key, value]) => ALLOWED_STYLES.has(key) && typeof value === 'string',
    ),
  );
}
